import { Accordion as MuiAccordion, AccordionProps } from "@material-ui/core";
import React from "react";

export const Accordion = ({ children, ...props }: AccordionProps) => {
  return <MuiAccordion {...props}>{children}</MuiAccordion>;
};
